module.exports = __webpack_public_path__ + "media/form-type-page/file-6c5d1d47.svg";